export const FORD_UPDATE_DISPLAY_FILTER = 'FORD_UPDATE_DISPLAY_FILTER'

export function updateDisplayFilter(data) {
  return {
    type: FORD_UPDATE_DISPLAY_FILTER,
    data,
  }
}
